import { useSelector } from "react-redux";

const StoreOffers = () => {
  return (
    <>
      <div className="iframe-div">
        <iframe
          title="Report Section"
          width="600"
          height="373.5"
          src="https://iiplwork.retool.com/embedded/public/7462c961-1829-4baf-965b-7f3c2434346b"
          frameborder="0"
          allowFullScreen="true"
        ></iframe>
      </div>
    </>
  );
};
export default StoreOffers;
